module.exports = __webpack_public_path__ + "media/Video 118.771a3867.mp4";